import { Navigate, Outlet, useLocation } from "react-router";

import { BrandLoader } from "@/client/components/brand-loader";
import { useUser } from "@/client/services/user";
import { Role } from "@reactive-resume/utils";

export const AuthAdmGuard = () => {
  const location = useLocation();
  const redirectTo = location.pathname + location.search;

  const { user, loading } = useUser();
  if (loading) return <BrandLoader fullScreen />;

  if (user) {
    if (user.isInternal) return <Outlet />;
  }

  return <Navigate replace to={`/admin/auth/login`} />;
};
